import { type ReactElement, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';

import { useAuth } from '@/api';
import { logoutRoute } from '@/constants';

import { brokerReturnUrl, goToBrokerUrl } from '../brokerReturnUrl';

export const nextPathFrom = (search: string) => {
  const next = new URLSearchParams(search).get('next');
  return next?.startsWith('/') && !next.startsWith('//') ? next : '/';
};

export const RequireLoggedOut = ({ children }: { children: ReactElement }) => {
  const { pathname, search } = useLocation();
  const user = useAuth();

  const isLogOutRequest = pathname.startsWith(logoutRoute);
  const brokerUrl =
    user && !isLogOutRequest
      ? brokerReturnUrl(new URLSearchParams(search).get('next'))
      : null;

  useEffect(() => {
    if (brokerUrl) goToBrokerUrl(brokerUrl);
  }, [brokerUrl]);

  if (brokerUrl) return null;
  if (user && !isLogOutRequest)
    return <Navigate to={nextPathFrom(search)} replace />;

  return children;
};
